// extracted by mini-css-extract-plugin
export var lg = "1240";
export var md = "768";
export var sm = "576";
export var xl = "1450";